import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import SwymWishlistBtnPdp from '../SwymWishlistBtnPdp/SwymWishlistBtnPdp';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { getEncodedVariantId } from '../../Utils/VariantUtils';
import { isValidEmailAddress } from '../../Utils/ProductUtils';
import { StyledWrapper, StyledButtonWrapper, StyledButton, StyledPdpButton, MonogramLink } from './AddToCartBtnStyles';
import { getVendorCustomAttribute } from '../../Utils/CartUtils';
import { IconCart } from '../Icons';

var _ref = React.createElement(LoadingSpinner, null);

var _ref2 = React.createElement(
  Fragment,
  null,
  'Add to Cart'
);

var _ref3 = React.createElement(LoadingSpinner, null);

var _ref4 = React.createElement(
  Fragment,
  null,
  'Add to Cart'
);

var _ref5 = React.createElement(
  StyledButton,
  { disabled: true },
  'Sold Out'
);

var AddToCartBtn = function AddToCartBtn(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      addingToCart = _useState2[0],
      setAddingToCart = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showSuccessMessage = _useState4[0],
      setShowSuccessMessage = _useState4[1];

  var isMounted = useRef(false);

  useEffect(function () {
    isMounted.current = true;
    return function () {
      return isMounted.current = false;
    };
  }, []);

  var handleAddToCartClick = function handleAddToCartClick() {
    if (props.isMonogramProduct && props.monogramInputValue === '') {
      props.setMonogramError(true);
      return;
    }

    // KLAVIYO TRACKING
    // Note: Logic ensures this only occurs for main PDP ATC button (not other instances on PDP)
    if (window.location.pathname.includes('/products/') && props.btnStyle === 'PRODUCT') {
      window._learnq.push(['track', 'Added to Cart', window.DormifyKlayvio.item]);
    }

    // Virtual Gift Card form validation
    if (props.virtualGiftCardValues) {
      var valObj = Object.assign({
        sName: props.virtualGiftCardValues['sName'],
        sEmail: props.virtualGiftCardValues['sEmail']
      }, props.virtualGiftCardSelectOption !== 'myself' && {
        rName: props.virtualGiftCardValues['rName'],
        rEmail: props.virtualGiftCardValues['rEmail']
      });

      // Check for blank values
      if (Object.values(valObj).some(function (v) {
        return v === '';
      })) {
        Object.keys(valObj).filter(function (key) {
          return props.virtualGiftCardValues[key] === '';
        }).forEach(function (key) {
          props.handleVirtualGiftCardError(key, true);
        });
        return;
      }
      // Validate email pattern on each email field
      if (props.virtualGiftCardSelectOption === 'myself' && !isValidEmailAddress(props.virtualGiftCardValues['sEmail']) || props.virtualGiftCardSelectOption !== 'myself' && !isValidEmailAddress(props.virtualGiftCardValues['rEmail'])) {
        if (!isValidEmailAddress(props.virtualGiftCardValues['sEmail'])) {
          props.handleVirtualGiftCardError('sEmail', true);
        }

        if (!isValidEmailAddress(props.virtualGiftCardValues['rEmail'])) {
          props.handleVirtualGiftCardError('rEmail', true);
        }

        return;
      }
    }
    setAddingToCart(true);
    props.addVariantToCart([{
      variantId: props.selectedVariantId,
      quantity: props.selectedVariantQuantity,
      customAttributes: customAttributes
    }], function () {
      if (props.addOnListSelectedItems && props.addOnListSelectedItems.length > 0) {
        var addOnItemsForCart = props.addOnListSelectedItems.map(function (product) {
          return {
            variantId: getEncodedVariantId(product.sku),
            quantity: 1,
            customAttributes: getVendorCustomAttribute(product.vendor)
          };
        });
        props.addVariantToCart(addOnItemsForCart);
      }
      if (isMounted.current) {
        setAddingToCart(false);
      }
      // if product button is clicked, set atc Clicked to true on callback func
      // this will fire ProductAddOnModal if DY has AddOn products
      if (isMounted.current && props.btnStyle === 'PRODUCT') {
        props.setAtcClicked(true);

        // Reset Virtual Gift Card if is vgc
        if (props.setInitialStateVirtualGiftCardForm) props.setInitialStateVirtualGiftCardForm();
      }

      if (isMounted.current && props.btnStyle === 'COLLECTION') setShowSuccessMessage(true);
    });
  };

  // Revert Success message
  useEffect(function () {
    if (showSuccessMessage) {
      // Revert after 3 seconds
      setTimeout(function () {
        setShowSuccessMessage(false);
      }, 3000);
    }
  }, [showSuccessMessage]);

  // ADD BUNDLE PRODUCTS (for bundles)
  var handleAddBundleProductsToCart = function handleAddBundleProductsToCart() {
    setAddingToCart(true);
    var availableProducts = props.bundleProducts.filter(function (prod) {
      return prod.product.availableForSale;
    });

    var addToCartItems = availableProducts.map(function (product) {
      var itemQuantity = product.product.tags.some(function (tag) {
        return tag.includes('bundle-quantity--');
      }) ? parseInt(product.product.tags.find(function (tag) {
        return tag.includes('bundle-quantity--');
      }).replace('bundle-quantity--', '')) : props.selectedVariantQuantity;
      return {
        variantId: product.selectedVariant.id,
        quantity: itemQuantity,
        customAttributes: getVendorCustomAttribute(product.product.vendor)
      };
    });
    props.addVariantToCart(addToCartItems, function () {
      if (isMounted.current) setAddingToCart(false);
    });
  };

  var useProductPageStyles = props.btnStyle === 'PRODUCT' || props.btnStyle === 'MODAL';

  var customAttributes = getVendorCustomAttribute(props.product.vendor);

  var monogramProduct = props.product.tags.includes('use-monogram-field');
  var productHref = '/products/' + props.product.handle;

  var virtualGiftCardProduct = props.product.handle.includes('digital-gift-card');

  if (props.monogramInputValue) {
    // remove emojis and special characters
    var value = props.monogramInputValue.replace(/[^a-z0-9\s]/gi, '');
    customAttributes.push({ key: 'Text', value: value });
  }

  if (props.customCollection) {
    customAttributes.push({ key: '_cc', value: props.collectionTitle });
  }

  // Preorder on Product Level
  if (props.product.preorderDate) {
    customAttributes.push({
      key: '_productPreorder',
      value: JSON.stringify(props.product.preorderDate)
    });
  }

  // Displays Not Eligible ForDiscountProduct
  if (props.ineligibleForDiscount) {
    customAttributes.push({ key: '_notEligibleDiscount', value: 'true' });
  }

  // For Shipping Surcharge lineItem copy
  // #TEMPSHIPPINGSURCHARGE
  if (props.shippingSurcharge) {
    customAttributes.push({ key: '_shippingSurcharge', value: 'true' });
  }

  // Set custom attributes for Virtual Gift Card
  // from VirtualGiftCardProductForm values
  if (props.virtualGiftCardValues) {
    if (props.virtualGiftCardValues.rName !== '') {
      customAttributes.push({
        key: '_vgcRecipientName',
        value: props.virtualGiftCardValues.rName
      });
    }

    if (props.virtualGiftCardValues.rEmail !== '') {
      customAttributes.push({
        key: '_vgcRecipientEmail',
        value: props.virtualGiftCardValues.rEmail
      });
    }

    if (props.virtualGiftCardValues.sName !== '') {
      customAttributes.push({
        key: '_vgcSenderName',
        value: props.virtualGiftCardValues.sName
      });
    }

    if (props.virtualGiftCardValues.sEmail !== '') {
      customAttributes.push({
        key: '_vgcSenderEmail',
        value: props.virtualGiftCardValues.sEmail
      });
    }

    if (props.virtualGiftCardValues.message !== '') {
      customAttributes.push({
        key: '_vgcMessage',
        // Remove line breaks and emojis
        value: props.virtualGiftCardValues.message.replace(/(\r\n|\n|\r)/gm, ' ').replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '').replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, '')
      });
    }
  }

  return React.createElement(
    StyledWrapper,
    {
      collectionStyles: props.btnStyle === 'COLLECTION',
      useDropdown: props.useDropdown
    },
    props.variantExists ? props.selectedVariantAvailable ? (virtualGiftCardProduct || monogramProduct) && props.btnStyle === 'COLLECTION' ? React.createElement(
      MonogramLink,
      {
        useProductPageStyles: useProductPageStyles,
        href: productHref
      },
      virtualGiftCardProduct ? 'Send a Gift Card' : 'Customize'
    ) : props.btnStyle === 'COLLECTION' ? React.createElement(
      StyledButton,
      {
        className: useProductPageStyles && 'PDP-add-to-cart gradient-shimmer',
        onClick:
        // If bundle product, add bundle products
        props.bundleProductHandle ? handleAddBundleProductsToCart : handleAddToCartClick,
        showSuccessMessage: showSuccessMessage
      },
      addingToCart ? _ref : showSuccessMessage ? 'Added!' : _ref2
    ) : React.createElement(
      StyledButtonWrapper,
      { useProductPageStyles: useProductPageStyles },
      React.createElement(
        StyledPdpButton,
        {
          className: 'PDP-add-to-cart gradient-shimmer',
          useProductPageStyles: useProductPageStyles,
          onClick:
          // If bundle product, add bundle products
          props.bundleProductHandle ? handleAddBundleProductsToCart : handleAddToCartClick,
          showSuccessMessage: showSuccessMessage
        },
        addingToCart ? _ref3 : showSuccessMessage ? 'Added!' : _ref4
      ),
      props.btnStyle === 'PRODUCT' && React.createElement(SwymWishlistBtnPdp, {
        product: props.product,
        selectedVariant: props.selectedVariant,
        isWishlistProduct: props.isWishlistProduct,
        toggleAccountModal: props.toggleAccountModal,
        productPage: true
      })
    ) : props.btnStyle === 'PRODUCT' && !props.product.tags.includes('no-restock') ?
    // Show Back in stock button on pdp page
    React.createElement(
      StyledButtonWrapper,
      {
        isSoldOut: true,
        useProductPageStyles: useProductPageStyles
      },
      React.createElement(
        StyledPdpButton,
        {
          useProductPageStyles: useProductPageStyles,
          className: 'btn',
          id: 'BIS_trigger'
        },
        'Join Waitlist'
      ),
      React.createElement(SwymWishlistBtnPdp, {
        product: props.product,
        selectedVariant: props.selectedVariant,
        isWishlistProduct: props.isWishlistProduct,
        toggleAccountModal: props.toggleAccountModal
      })
    ) : _ref5 : React.createElement(
      StyledButton,
      { disabled: true, useProductPageStyles: useProductPageStyles },
      'UNAVAILABLE'
    )
  );
};

AddToCartBtn.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  selectedVariantId: PropTypes.string.isRequired,
  variantExists: PropTypes.bool.isRequired,
  selectedVariantAvailable: PropTypes.bool.isRequired,
  selectedVariantQuantity: PropTypes.number.isRequired,
  collectionTitle: PropTypes.string,
  btnStyle: PropTypes.oneOf(['PRODUCT', 'MODAL', 'COLLECTION']),
  monogramInputValue: PropTypes.string,
  setAtcClicked: PropTypes.func,
  customCollection: PropTypes.bool,
  useDropdown: PropTypes.bool,
  isMonogramProduct: PropTypes.bool,
  setMonogramError: PropTypes.func,
  bundleProducts: PropTypes.array,
  bundleProductHandle: PropTypes.string,
  addOnListSelectedItems: PropTypes.array,
  shippingSurcharge: PropTypes.bool,
  virtualGiftCardValues: PropTypes.object,
  virtualGiftCardSelectOption: PropTypes.string,
  handleVirtualGiftCardError: PropTypes.func,
  setInitialStateVirtualGiftCardForm: PropTypes.func,
  ineligibleForDiscount: PropTypes.bool,
  selectedVariant: PropTypes.object,
  isWishlistProduct: PropTypes.bool,
  toggleAccountModal: PropTypes.func
};
export default AddToCartBtn;